/** @format */

import {
  Box,
  Button,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  Stack,
  SvgIcon,
  Typography,
  useMediaQuery
} from '@mui/material';
import File03Icon from '@untitled-ui/icons-react/build/esm/File03';
import InfoCircleIcon from '@untitled-ui/icons-react/build/esm/InfoCircle';
import User03Icon from '@untitled-ui/icons-react/build/esm/User03';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { RouterLink } from 'src/components/router-link';
import { userValueTextRoles } from 'src/config';
import { useAuth } from 'src/hooks/use-auth';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';
import ModalAbout from 'src/sections/account/modal-about';
import ActionLog from 'src/sections/account/modal-actionlog';

export const AccountPopover = (props) => {
  const { anchorEl, onClose, open, ...other } = props;
  const router = useRouter();
  const { user, ...auth } = useAuth();
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up('md'));
  // const user = useMockedUser();
  const [openAbout, setOpenAbout] = React.useState(false);
  const [openActionLog, setOpenActionLog] = React.useState(false);

  const handleLogout = useCallback(async () => {
    try {
      onClose?.();

      await auth.signOut();
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong!');
    }
  }, [auth, router, onClose]);

  const handleCloseAbout = () => {
    setOpenAbout(false);
  };
  const handleCloseActionLog = () => {
    setOpenActionLog(false);
  };
  return (
    <>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom'
        }}
        disableScrollLock
        onClose={onClose}
        open={!!open}
        slotProps={{
          paper: {
            sx: { minWidth: 200 }
          }
        }}
        {...other}
      >
        <Box sx={{ p: 2 }}>
          {!mdUp && (
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {user.displayName}
              </Typography>
              <Typography variant="caption" gutterBottom>
                {get(userValueTextRoles, user.role)}
              </Typography>
            </Stack>
          )}

          <Typography color="text.secondary" variant="body2">
            {user.email || user.phoneNumber}
          </Typography>
        </Box>
        <Divider />
        <Box sx={{ p: 1 }}>
          <ListItemButton
            component={RouterLink}
            href={paths.account.index}
            onClick={onClose}
            sx={{
              borderRadius: 1,
              px: 1,
              py: 0.5
            }}
          >
            <ListItemIcon>
              <SvgIcon fontSize="small">
                <User03Icon />
              </SvgIcon>
            </ListItemIcon>
            <ListItemText primary={<Typography variant="body1">My Profile</Typography>} />
          </ListItemButton>

          {/* <ListItemButton
            component={RouterLink}
            href={paths.dashboard.social.profile}
            onClick={onClose}
            sx={{
              borderRadius: 1,
              px: 1,
              py: 0.5,
            }}
          >
            <ListItemIcon>
              <SvgIcon fontSize='small'>
                <UserEditIcon />
              </SvgIcon>
            </ListItemIcon>
            <ListItemText
              primary={<Typography variant='body1'>My Account</Typography>}
            />
          </ListItemButton> */}

          <ListItemButton
            component={RouterLink}
            href="#"
            sx={{
              borderRadius: 1,
              px: 1,
              py: 0.5
            }}
            onClick={() => {
              onClose();
              setOpenActionLog(true);
            }}
          >
            <ListItemIcon>
              <SvgIcon fontSize="small">
                <File03Icon />
              </SvgIcon>
            </ListItemIcon>
            <ListItemText primary={<Typography variant="body1">Action Log</Typography>} />
          </ListItemButton>

          <ListItemButton
            component={RouterLink}
            href="#"
            sx={{
              borderRadius: 1,
              px: 1,
              py: 0.5
            }}
            onClick={() => {
              onClose();
              setOpenAbout(true);
            }}
          >
            <ListItemIcon>
              <SvgIcon fontSize="small">
                <InfoCircleIcon />
              </SvgIcon>
            </ListItemIcon>
            <ListItemText primary={<Typography variant="body1">About</Typography>} />
          </ListItemButton>
        </Box>
        <Divider sx={{ my: '0 !important' }} />
        <Box
          sx={{
            display: 'flex',
            p: 1,
            justifyContent: 'center'
          }}
        >
          <Button color="inherit" onClick={handleLogout} size="small">
            Logout
          </Button>
        </Box>
      </Popover>
      <ModalAbout open={openAbout} handleClose={handleCloseAbout} />
      <ActionLog open={openActionLog} handleClose={handleCloseActionLog} />
    </>
  );
};

AccountPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool
};
